import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sub-navbar-v2',
  imports: [],
  templateUrl: './sub-navbar-v2.component.html',
})
export class SubNavbarV2Component {
  router = inject(Router);

  @Input()
  buttonText = "Suivant"

  @Input()
  isValid = false

  @Output()
  onNext = new EventEmitter<void>()

}
